import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { StoreWebhookLog } from 'app/shared/graph';

export type StoreWebhookLogDetailDialogData = {
    webhookLog: StoreWebhookLog
}

@Component({
    selector: 'admin-store-webhook-log-detail-dialog',
    imports: [
        FormsModule,
        MatDialogModule,
        MatButtonModule
    ],
    templateUrl: './store-webhook-log-detail-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './store-webhook-log-detail-dialog.component.scss'
})
export class StoreWebhookLogDetailDialogComponent {

    dialogRef = inject<MatDialogRef<StoreWebhookLogDetailDialogComponent>>(MatDialogRef);
    readonly data = inject<StoreWebhookLogDetailDialogData>(MAT_DIALOG_DATA);
}
